/**
 * Метрики раскроя: точный КИМ + каркас 5-критериальной оптимизации.
 *
 * CUT-4.1 считает `kim`/`wastePercent`/`schemeCount`/`packageCount` точно.
 * `multiCriteriaScore` — каркас формулы §5.1.7 (веса эмпирические); полное
 * применение (выбор лучшего из multi-pass + Pareto-фильтрация) — CUT-4.2.
 *
 * @see TRD §5.1.7
 */

import type { EngineMetrics } from './types';

/**
 * КИМ — коэффициент использования материала: площадь деталей / валовая площадь
 * использованных листов. Возвращает 0 при нулевой площади листов (нет раскроя).
 */
export function computeKim(placedPartsArea: number, usedSheetsArea: number): number {
  if (usedSheetsArea <= 0) return 0;
  return placedPartsArea / usedSheetsArea;
}

/**
 * Взвешенная сумма 5 критериев (§5.1.7), нормированных в [0..1]. Меньше — лучше.
 * Каркас для CUT-4.2 (выбор лучшего варианта среди проходов). В CUT-4.1 проход
 * один, поэтому функция предоставлена и протестирована, но не управляет выбором.
 */
export function multiCriteriaScore(metrics: EngineMetrics): number {
  const norm = {
    waste: clamp01(metrics.wastePercent / 100),
    schemes: clamp01(metrics.schemeCount / 20),
    cutLen: clamp01(metrics.cutLengthMeters / 200),
    cuts: clamp01(metrics.cutCount / 500),
    pkgs: clamp01(metrics.packageCount / 10),
  };
  const W = { waste: 0.4, schemes: 0.15, cutLen: 0.2, cuts: 0.15, pkgs: 0.1 };
  return (
    W.waste * norm.waste +
    W.schemes * norm.schemes +
    W.cutLen * norm.cutLen +
    W.cuts * norm.cuts +
    W.pkgs * norm.pkgs
  );
}

function clamp01(v: number): number {
  if (v < 0) return 0;
  if (v > 1) return 1;
  return v;
}
